import React, { FC, useState } from 'react';
import { HStack, IconButton } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { CloseIcon } from 'components/icons';
import { Input } from 'components/Form/Input';

export type FieldOptionType = {
  value: string;
  text: string;
};

interface FieldOptionProps {
  leftInput: React.ReactElement;
  option: FieldOptionType;
  isDisabled: boolean;
  handleFieldOptionChange: (e: any, option: FieldOptionType) => void;
  handleFieldOptionRemoval: (option: FieldOptionType) => void;
  placeholder: string;
}

export const FieldOption: FC<FieldOptionProps> = ({
  leftInput,
  option,
  isDisabled,
  placeholder,
  handleFieldOptionChange,
  handleFieldOptionRemoval,
}) => {
  const [text, setText] = useState(option.text);

  return (
    <HStack align="center" justify="center">
      {leftInput}
      <Input
        mb={3}
        variant="flushed"
        value={text}
        isDisabled={isDisabled}
        onChange={(e) => {
          setText(e.target.value);
          handleFieldOptionChange(e, option);
        }}
        placeholder={placeholder}
      />
      <IconButton
        aria-label={t`Remove checkbox option`}
        icon={<CloseIcon />}
        size="sm"
        borderRadius="full"
        variant="ghost"
        isDisabled={isDisabled}
        onClick={() => handleFieldOptionRemoval(option)}
      />
    </HStack>
  );
};
